let selectedSamples = [];
let samplesInfo = {};

// Scroll lock helpers (fallback for older iOS)
function lockBodyScroll() {
  try {
    // Do not reference sidebar state here; samples-block must be decoupled
    const scrollY = window.scrollY || window.pageYOffset || 0;
    document.body.dataset.samplesScrollY = String(scrollY);
    const hasScrollbar = window.innerWidth > document.documentElement.clientWidth;
    const scrollbarWidth = hasScrollbar ? (window.innerWidth - document.documentElement.clientWidth) : 0;
    if (scrollbarWidth) {
      document.documentElement.style.setProperty('--samples-scrollbar-width', scrollbarWidth + 'px');
      document.body.style.paddingRight = 'var(--samples-scrollbar-width)';
    }
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.style.overscrollBehavior = 'none';
  } catch(_) {}
}

function unlockBodyScroll() {
  try {
    const y = parseInt(document.body.dataset.samplesScrollY || '0', 10);
    document.body.style.removeProperty('position');
    document.body.style.removeProperty('top');
    document.body.style.removeProperty('width');
    document.body.style.removeProperty('padding-right');
    document.body.style.removeProperty('overscroll-behavior');
    delete document.body.dataset.samplesScrollY;
    window.scrollTo(0, y);
  } catch(_) {}
}

function updateSamplesSelection() {
  const checked = document.querySelectorAll('.swatch__item_checkbox:checked');
  selectedSamples = Array.from(checked).map((cb) => {
    const item = cb.closest('.swatch__item');
    const priceAttr = item && item.getAttribute('data-price');
    const price = priceAttr ? parseFloat(priceAttr) : 0;
    return {
      id: parseInt(item.getAttribute('data-product-id'), 10),
      price: isNaN(price) ? 0 : price,
    };
  });
  
  const countEl = document.getElementById('samplesCount');
  const countElText = document.getElementById('samplesCount').dataset.text;
  const totalEl = document.getElementById('samplesTotal');
  const totalPrice = selectedSamples.reduce((sum, s) => sum + (s.price || 0), 0);
  if (countEl) countEl.textContent = `${selectedSamples.length} ${countElText}`;
  if (totalEl) totalEl.textContent = formatMoney(totalPrice);
  
  const btn = document.querySelector('.samples__add-to-cart');
  if (btn) {
    btn.disabled = selectedSamples.length === 0;
    if (selectedSamples.length === 0) {
      btn.classList.add('disabled');
    } else {
      btn.classList.remove('disabled');
    }
  }
  
  updateActiveStates();
}

function formatMoney(amount) {
  try {
    const slider = document.getElementById('samplesSlider');
    const code = slider ? slider.getAttribute('data-currency') : '';
    const symbol = slider ? slider.getAttribute('data-currency-symbol') : '';

    const number = new Intl.NumberFormat(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
    
    if (symbol) return `${symbol}${number}`;
    if (code) return number;
  } catch(_) {}
  return `${amount.toFixed(2)}`;
}

function addSamplesToCart() {
  if (!selectedSamples.length) return;

  const itemsToAdd = selectedSamples.map((s) => ({ id: s.id, quantity: 1 }));

  const addBtn = document.querySelector('.samples__add-to-cart');
  if (addBtn) {
    addBtn.classList.add('loading');
    addBtn.disabled = true;
    if (!addBtn.querySelector('.btn-spinner')) {
      const sp = document.createElement('span');
      sp.className = 'btn-spinner';
      addBtn.appendChild(sp);
    }
    if (!addBtn.querySelector('.btn-label')) {
      const label = document.createElement('span');
      label.className = 'btn-label';
      while (addBtn.firstChild && !addBtn.firstChild.classList?.contains('btn-spinner')) {
        label.appendChild(addBtn.firstChild);
      }
      addBtn.insertBefore(label, addBtn.firstChild);
    }
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: itemsToAdd
    })
  })
  .then(response => response.json())
  .then(data => {
    if (data.status === 422) {
      throw new Error(data.description || 'Error adding to cart');
    }
    
    // Update cart content and count
    fetch('?section_id=helper-cart')
      .then(response => response.text())
      .then(text => {
        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
        
        // Update cart items
        const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm');
        const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal');
        
        if (cartFormInnerHTML && document.getElementById('AjaxCartForm')) {
          document.getElementById('AjaxCartForm').innerHTML = cartFormInnerHTML.innerHTML;
          // Re-initialize cart items functionality
          if (document.getElementById('AjaxCartForm').ajaxifyCartItems) {
            document.getElementById('AjaxCartForm').ajaxifyCartItems();
          }
        }
        
        if (cartSubtotalInnerHTML && document.getElementById('AjaxCartSubtotal')) {
          document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML.innerHTML;
        }
        
        // Update header cart count
        const cartCount = sectionInnerHTML.querySelector('#AjaxCartForm [data-cart-count]');
        if (cartCount) {
          document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
            elm.innerHTML = cartCount.innerHTML;
          });
        }
        
        // Update cart recommendations if they exist
        if (document.getElementById('cart-recommendations-sidebar')) {
          document.getElementById('cart-recommendations-sidebar').generateRecommendations();
        }
        
        // Show cart sidebar after content is updated
        if (document.getElementById('site-cart-sidebar')) {
          document.getElementById('site-cart-sidebar').show();
        }
      });
    
    try {
      closeSamplesDrawer();
    } catch (_) {}
    try {
      resetSamplesSelection();
    } catch (_) {}
  })
  .catch(error => {
    console.error('Error:', error);
    showNotification(error.message || 'Error adding to cart', 'error');
  })
  .finally(() => {
    const btn = document.querySelector('.samples__add-to-cart');
    if (btn) {
      btn.classList.remove('loading');
      btn.disabled = selectedSamples.length === 0;
    }
  });
}

function addSingleProductToCart(productId) {
  if (!productId) {
    return;
  }
  const itemsToAdd = [{ id: parseInt(productId), quantity: 1 }];

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: itemsToAdd
    })
  })
  .then(response => response.json())
  .then(data => {
    if (data.status === 422) {
      throw new Error(data.description || 'Error adding to cart');
    }
    
    // Update cart content and count
    fetch('?section_id=helper-cart')
      .then(response => response.text())
      .then(text => {
        const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
        
        // Update cart items
        const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm');
        const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal');
        
        if (cartFormInnerHTML && document.getElementById('AjaxCartForm')) {
          document.getElementById('AjaxCartForm').innerHTML = cartFormInnerHTML.innerHTML;
          // Re-initialize cart items functionality
          if (document.getElementById('AjaxCartForm').ajaxifyCartItems) {
            document.getElementById('AjaxCartForm').ajaxifyCartItems();
          }
        }
        
        if (cartSubtotalInnerHTML && document.getElementById('AjaxCartSubtotal')) {
          document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML.innerHTML;
        }
        
        // Update header cart count
        const cartCount = sectionInnerHTML.querySelector('#AjaxCartForm [data-cart-count]');
        if (cartCount) {
          document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
            elm.innerHTML = cartCount.innerHTML;
          });
        }
        
        // Update cart recommendations if they exist
        if (document.getElementById('cart-recommendations-sidebar')) {
          document.getElementById('cart-recommendations-sidebar').generateRecommendations();
        }
        
        // Show cart sidebar after content is updated
        if (document.getElementById('site-cart-sidebar')) {
          document.getElementById('site-cart-sidebar').show();
        }
      });
    
    try {
      closeSamplesDrawer();
    } catch (_) {}
  })
  .catch(error => {
    console.error('Error:', error);
    showNotification(error.message || 'Error adding to cart', 'error');
  });
}

function closeSamplesDrawer() {
  document.body.classList.remove('hc-samples-dawer-active');
  unlockBodyScroll();
  const label = document.querySelector('.hc-samples-drawer-label');
  if (label) label.classList.remove('active');
  const sliderWrapper = document.getElementById('samplesSlider');
  if (sliderWrapper) sliderWrapper.classList.remove('is-details');
  const slider = document.getElementById('inlineInfoPanel');
  if (slider) slider.classList.remove('active');
}

function resetSamplesSelection() {
  document.querySelectorAll('.swatch__item_checkbox').forEach(cb => cb.checked = false);
  selectedSamples = [];
  updateSamplesSelection();
  
  const btn = document.querySelector('.samples__add-to-cart');
  if (btn) btn.classList.add('disabled');
}

function showNotification(message, type = 'info') {
  const notification = document.createElement('div');
  notification.className = `notification notification-${type}`;
  notification.textContent = message;
  
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    padding: 15px 20px;
    border-radius: 6px;
    color: white;
    font-weight: 600;
    z-index: 99999;
    max-width: 300px;
    word-wrap: break-word;
  `;
  
  if (type === 'error') {
    notification.style.background = '#dc3545';
  } else {
    notification.style.background = '#28a745';
  }
  
  document.body.appendChild(notification);
  
  setTimeout(() => {
    if (notification.parentNode) {
      notification.parentNode.removeChild(notification);
    }
  }, 5000);
}

function getSamplesInfo() {
  if (Object.keys(samplesInfo).length) return samplesInfo;
  let el = document.getElementById('samples-settings-raw') || document.getElementById('samples-info-data');
  if (!el) return {};
  try {
    let raw = '';
    const tag = el.tagName.toLowerCase();
    if (tag === 'template') {
      raw = (el.content && el.content.textContent) || el.innerHTML || '';
    } else {
      raw = el.textContent || '';
    }
    raw = (raw || '').trim();
    samplesInfo = raw ? JSON.parse(raw) : {};
  } catch (e) {
    samplesInfo = {};
    console.error('Samples info JSON parse error:', e);
  }
  return samplesInfo;
}

function resolveInfoItem(info, key) {
  if (!info) return null;
  if (Array.isArray(info)) {
    const lower = String(key).toLowerCase();
    const props = ['key', 'handle', 'slug', 'id', 'uid', 'name', 'title'];
    let match = info.find((it) => props.some((p) => it && it[p] && String(it[p]).toLowerCase() === lower));
    if (!match) match = info.find((it) => it && it.title && String(it.title).toLowerCase().includes(lower));
    return match || null;
  }
  const k = String(key);
  return info[k] || info[key] || null;
}

// Reserve space for an image by setting the placeholder box height based on
// the intended intrinsic width/height ratio. Prevents layout shift before load.
function setAspectBoxSize(placeholderEl, intrinsicWidth, intrinsicHeight) {
  try {
    if (!placeholderEl) return;
    const iw = Math.max(1, Number(intrinsicWidth) || 1);
    const ih = Math.max(1, Number(intrinsicHeight) || 1);
    const ratio = ih / iw;
    const update = () => {
      const parent = placeholderEl.parentElement;
      const availableWidth = (parent ? parent.clientWidth : placeholderEl.clientWidth) || iw;
      placeholderEl.style.display = 'block';
      placeholderEl.style.width = '100%';
      placeholderEl.style.height = Math.round(availableWidth * ratio) + 'px';
    };
    update();
    if (window.ResizeObserver) {
      const ro = new ResizeObserver(update);
      ro.observe(placeholderEl.parentElement || placeholderEl);
    } else {
      window.addEventListener('resize', update, { passive: true });
    }
  } catch(_) {}
}

function showSampleInfo(key) {
  const info = getSamplesInfo();
  const product = resolveInfoItem(info, key);
  if (!product) return;
  
  const slider = document.getElementById('inlineInfoPanel');
  const sliderWrapper = document.getElementById('samplesSlider');
  const content = document.getElementById('inlineInfoContent');
  const backBtn = document.getElementById('inlineInfoBack');
  
  // Check if this is a Learn More item (starts with "learn-more-" or key exists in description element)
  const isLearnMore = String(key).startsWith('learn-more-') || document.querySelector(`[data-info-key="${key}"]`)?.classList.contains('fabric__description');
  
  const titleNow = product.title ? `<div class="samples__content_title">${product.title}</div> ` : '';
  const descNow = product.description ? `<div class="samples__content_description">${product.description}</div> ` : '';
  
  const drawerItems = document.querySelector('.hc-samples-drawer .hc-drawer-items');
  if (isLearnMore) {
    // For Learn More - show optional image (if provided) and description, without Add to cart
    if (drawerItems) drawerItems.classList.remove('hc-drawer-section--row');
    content.innerHTML = `<div class="samples__img_placeholder" id="samplesImgPh"></div><div class="samples__content_text">${titleNow} ${descNow}</div>`;
    try {
      const ph = document.getElementById('samplesImgPh');
      if (ph) {
        const iw = Number(product.image_width) || 4;
        const ih = Number(product.image_height) || 3;
        ph.style.setProperty('--samples-img-ratio', `${ih} / ${iw}`);
        setAspectBoxSize(ph, iw, ih);
      }
    } catch(_) {}
  } else {
    // For products - show everything as before
    if (drawerItems) drawerItems.classList.add('hc-drawer-section--row');
    const addToCartText = document.getElementById('addToCart').textContent;
    const addToCartBtn = `<button class="samples__add_to_cart_btn button button--solid" type="button" data-product-id="${product.variant_id || key}">${addToCartText}</button>`;
    content.innerHTML = `<div class="samples__img_placeholder" id="samplesImgPh"></div><div class="samples__content_text">${titleNow} ${descNow} ${addToCartBtn}</div>`;
    
    try {
      const ph = document.getElementById('samplesImgPh');
      if (ph) {
        const iw = Number(product.image_width) || 4;
        const ih = Number(product.image_height) || 3;
        ph.style.setProperty('--samples-img-ratio', `${ih} / ${iw}`);
        setAspectBoxSize(ph, iw, ih);
      }
    } catch(_) {}
  }
  
  if (backBtn) backBtn.style.display = 'inline-flex';
  requestAnimationFrame(() => {
    slider.classList.add('active');
    if (sliderWrapper) sliderWrapper.classList.add('is-details');
  });

  // Load image if provided
  {
    window.__samplesImgCache = window.__samplesImgCache || new Map();
    const url = product.image || '';
    const build = (img) => {
      const ph = document.getElementById('samplesImgPh');
      const w = product.image_width || (img ? img.naturalWidth : '') || '';
      const h = product.image_height || (img ? img.naturalHeight : '') || '';
      
      if (img) {
        const imageHTML = `<img class="samples__content_image" src="${url}" alt="${product.title || ''}" width="${w}" height="${h}" decoding="async" loading="eager" style="max-width: 100%; height: auto;">`;
        if (ph) ph.outerHTML = imageHTML; else content.insertAdjacentHTML('afterbegin', imageHTML);
      } else {
        if (ph) ph.style.display = 'block';
      }
    };

    if (!url) {
      build(null);
      return;
    }

    if (window.__samplesImgCache.has(url)) {
      const cached = window.__samplesImgCache.get(url);
      if (cached && cached.complete) {
        build(cached);
        return;
      }
    }

    const img = new Image();
    img.decoding = 'async';
    img.loading = 'eager';
    img.crossOrigin = 'anonymous';
    img.src = url;
    window.__samplesImgCache.set(url, img);
    img.onload = () => build(img);
    img.onerror = () => {
      console.warn('Failed to load image:', url);
      build(null);
    };
  }
}

function updateActiveStates() {
  document.querySelectorAll('.swatch__item').forEach(item => {
    const checkbox = item.querySelector('.swatch__item_checkbox');
    item.classList.toggle('swatch__item_active', checkbox && checkbox.checked);
  });
}

function hideSampleInfo() {
  const slider = document.getElementById('inlineInfoPanel');
  const sliderWrapper = document.getElementById('samplesSlider');
  const backBtn = document.getElementById('inlineInfoBack');
  if (sliderWrapper) sliderWrapper.classList.remove('is-details');
  slider.addEventListener('transitionend', function handler() {
    slider.classList.remove('active');
    slider.removeEventListener('transitionend', handler);
  });
  if (backBtn) backBtn.style.display = 'none';
}

document.addEventListener('DOMContentLoaded', function() {
  // Add Learn More buttons to fabric descriptions
  function addLearnMoreButtons() {
    const descriptions = document.querySelectorAll('.fabric__description');
    descriptions.forEach((desc, index) => {
      // Check if Learn More button already exists
      if (desc.querySelector('.learn-more-btn')) return;
      const descriptionsKey = desc.dataset.infoKey;
      const descriptionsButtonText = desc.dataset.textButton;
      
      // Find the last <p> tag in description
      const paragraphs = desc.querySelectorAll('p');
      const lastParagraph = paragraphs[paragraphs.length - 1];
      
      if (lastParagraph && descriptionsKey) {
        // Create Learn More button
        const learnMoreBtn = document.createElement('button');
        learnMoreBtn.type = 'button';
        learnMoreBtn.className = 'learn-more-btn';
        learnMoreBtn.setAttribute('data-info-key', descriptionsKey);
        learnMoreBtn.setAttribute('title', descriptionsButtonText);
        learnMoreBtn.textContent = descriptionsButtonText;
        
        // Add button inside the last paragraph
        lastParagraph.appendChild(learnMoreBtn);
      }
    });
  }
  
  // Add buttons on page load
  addLearnMoreButtons();
  
  // Re-add buttons if content changes (for dynamic content)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        addLearnMoreButtons();
      }
    });
  });
  
  // Observe changes in samples content
  const samplesContent = document.querySelector('.samples__content');
  if (samplesContent) {
    observer.observe(samplesContent, { childList: true, subtree: true });
  }

  function setDrawerTopHeightVar() {
    try {
      const drawer = document.querySelector('.hc-popup-drawer.hc-samples-drawer');
      if (!drawer) return;
      const header = drawer.querySelector('.hc-samples-drawer-top');
      const headerH = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
      drawer.style.setProperty('--hc-samples-top-height', headerH + 'px');
      document.documentElement.style.setProperty('--hc-samples-top-height', headerH + 'px');
    } catch (_) {}
  }

  setDrawerTopHeightVar();
  window.addEventListener('resize', setDrawerTopHeightVar);
  window.addEventListener('orientationchange', setDrawerTopHeightVar);
  window.addEventListener('pageshow', setDrawerTopHeightVar);
  const headerEl = document.querySelector('.hc-samples-drawer-top');
  if (window.ResizeObserver && headerEl) {
    const ro = new ResizeObserver(setDrawerTopHeightVar);
    ro.observe(headerEl);
  }

  function setSamplesAvailHeight() {
    try {
      const drawer = document.querySelector('.hc-popup-drawer.hc-samples-drawer');
      const header = document.querySelector('.hc-samples-drawer-top');
      if (!drawer || !header) return;
      const vp = window.visualViewport?.height || window.innerHeight || 0;
      const h = Math.ceil(header.getBoundingClientRect().height || 0);
      const avail = Math.max(0, Math.floor(vp - h - 1));
      drawer.style.setProperty('--samples-avail', avail + 'px');
    } catch(_) {}
  }
  setSamplesAvailHeight();
  window.addEventListener('resize', setSamplesAvailHeight);
  window.addEventListener('orientationchange', setSamplesAvailHeight);
  window.addEventListener('pageshow', setSamplesAvailHeight);

  document.addEventListener('change', function(e) {
    if (e.target && e.target.matches && e.target.matches('.swatch__item_checkbox')) {
      updateSamplesSelection();
    }
  });

  document.addEventListener('click', function(e) {
    const swatchItem = e.target && e.target.closest && e.target.closest('.swatch__item');
    if (swatchItem && !e.target.closest('.swatch__item_icon') && !e.target.matches('.swatch__item_checkbox')) {
      const checkbox = swatchItem.querySelector('.swatch__item_checkbox');
      if (checkbox) {
        checkbox.checked = !checkbox.checked;
        updateSamplesSelection();
      }
    }
  });

  document.addEventListener('click', function(e) {
    const infoBtn = e.target && e.target.closest && e.target.closest('.swatch__item_icon');
    if (infoBtn) {
      const key = infoBtn.getAttribute('data-info-key');
      if (key) showSampleInfo(key);
    }
  });

  document.addEventListener('click', function(e) {
    const learnMoreBtn = e.target && e.target.closest && e.target.closest('.learn-more-btn');
    if (learnMoreBtn) {
      const key = learnMoreBtn.getAttribute('data-info-key');
      if (key) showSampleInfo(key);
    }
  });

  const backBtn = document.getElementById('inlineInfoBack');
  if (backBtn) {
    backBtn.addEventListener('click', function(e){
      e.preventDefault();
      hideSampleInfo();
    });
  }

  const closeBtn = document.querySelector('.samples-block__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function(e){ e.preventDefault(); hideSampleInfo(); });
  }

  document.addEventListener('click', function(e) {
    const addBtn = e.target && e.target.closest && e.target.closest('.samples__add-to-cart');
    if (addBtn) {
      e.preventDefault();
      if (!addBtn.querySelector('.btn-spinner')) {
        const sp = document.createElement('span');
        sp.className = 'btn-spinner';
        addBtn.appendChild(sp);
      }
      if (!addBtn.querySelector('.btn-label')) {
        const label = document.createElement('span');
        label.className = 'btn-label';
        while (addBtn.firstChild) {
          label.appendChild(addBtn.firstChild);
        }
        addBtn.appendChild(label);
        addBtn.appendChild(addBtn.querySelector('.btn-spinner'));
      }
      addSamplesToCart();
    }
  });

  document.addEventListener('click', function(e) {
    if (e.target && e.target.matches && e.target.matches('.samples__add_to_cart_btn')) {
      e.preventDefault();
      
      e.target.classList.add('loading');
      e.target.disabled = true;
      
      const productId = e.target.getAttribute('data-product-id');
      addSingleProductToCart(productId);
      
      setTimeout(() => {
        e.target.classList.remove('loading');
        e.target.disabled = false;
      }, 1000);
    }
  });

  const drawerOpenTrigger = document.querySelector('.hc-samples-drawer-label');

  if (drawerOpenTrigger) {
    drawerOpenTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (drawerOpenTrigger) drawerOpenTrigger.classList.add('active');
      document.body.classList.add('hc-samples-dawer-active');
      lockBodyScroll();
    });
  }

  const drawerCloseBtn = document.querySelector('.hc-samples-drawer-top .cros');
  if (drawerCloseBtn) {
    drawerCloseBtn.addEventListener('click', (e) => {
      e.preventDefault();
      closeSamplesDrawer();
    });
  }

  const drawerOverlay = document.querySelector('.hc-samples-drawer-overlay');
  if (drawerOverlay) {
    drawerOverlay.addEventListener('click', (e) => {
      e.preventDefault();
      closeSamplesDrawer();
    });
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      closeSamplesDrawer();
    }
  });

  updateSamplesSelection();
  updateActiveStates();
});

window.addSamplesToCart = addSamplesToCart;